import Swiper, {Navigation, Pagination, Thumbs} from 'swiper/core';

Swiper.use([Navigation, Pagination, Thumbs]);

// init Swiper:

function initDetailSwiper() {
    let detailsThumbs = new Swiper('.js-is-swiper__details--thumbs', {
        spaceBetween: 15,
        slidesPerView: 3,
        freeMode: false,
        watchOverflow: true,
        autoHeight: true,
        observer: true,
        observeParents: true,
        threshold: 30,
        pagination: {
            el: '.is-swiper-pagination',
            clickable: true
        },
        breakpoints: {
            420: {
                slidesPerView: 4
            },
            520: {
                slidesPerView: 5
            },
            768: {
                slidesPerView: 6
            },
            992: {
                slidesPerView: 4
            }
        }
    });

    let detailsTop = new Swiper('.js-is-swiper__details', {
        // Navigation arrows
        navigation: {
            nextEl: '.js-swiper-button-next',
            prevEl: '.js-swiper-button-prev',
        },
        freeMode: false,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        threshold: 30,
        thumbs: {
            swiper: detailsThumbs
        },
        on: {
            beforeSlideChangeStart: function (e) {
                //console.log('beforeSlideChangeStart');
            },
            activeIndexChange: function (e) {
                let el = $(e.$el[0].children[0].children[(detailsTop.activeIndex)])
                $(e.$el[0].children[0]).find('.swiper-slide').find('img').removeClass('zoom_image');
                $('.zoomContainer').remove();
                el.find('img').addClass('zoom_image');
                initImageZoom();
            }
        },
        autoHeight: true
    });
}

initDetailSwiper();

function initImageZoom() {
    $(".zoom_image").ezPlus({
        zoomType: 'lens',
        lensSize: 230,
        responsive: true,
        borderColour: '#cccccc',
        borderSize: 1
    });
}

$(document).ready(function () {
    initImageZoom();
    $('.bg-white-img-pdp').css('background-color', '#ffffff');
});
